import { jsx as n } from "react/jsx-runtime";
import { d as e, a6 as s } from "../../vendor-EQDp64ng.js";
import { getButtonStyles as a } from "../BaseButton/index.js";
import '../../assets/index53.css';const c = "_skipToContent_69s7u_1", r = {
  skipToContent: c
}, f = ({ targetId: t = "main-content" }) => {
  const o = e(a({ variant: "secondary" }), r.skipToContent);
  return /* @__PURE__ */ n(
    s,
    {
      href: `#${t}`,
      className: o,
      target: "_self",
      "data-component": "SkipToContent",
      children: "Skip to main content"
    }
  );
};
export {
  f as SkipToContent
};
